jQuery(document).ready(function ($) {
    $('.owl-carousel.content-slider').owlCarousel({
        loop: true,
        lazyLoad: true,
        dots: true,
        items: 1,
        nav: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 7500,
        autoplayHoverPause: true,
    });
    
    $('.owl-carousel.content-slider').on('mouseover.owl.autoplay', function(e) {
      $('.owl-carousel.content-slider').trigger('stop.owl.autoplay');
      var carousel = $('.owl-carousel.content-slider').data('owl.carousel');
      carousel.settings.autoplay = false;
      carousel.options.autoplay = false;
      $('.owl-carousel.content-slider').trigger('refresh.owl.carousel');
    });
  
    $('.owl-carousel.blog-slider').owlCarousel({
        loop: true,
        lazyLoad: true,
        dots: true,
        items: 1,
        nav: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
                loop: true
            }
        }
    });

    $('.owl-carousel.logo-slider').owlCarousel({
        loop: true,
        lazyLoad: true,
        margin: 10,
        dots: false,
        items: 4,
        nav: true,
        responsiveClass: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                loop: true
            }
        }
    });




    $(document).on('click', '.card-actions .share-icon-link', function (e) {
        $(this).next(".social-hover").toggleClass('changing-social');
        e.stopPropagation();
    });

    $(".social-hover").click(function (e) {
        e.stopPropagation();
    });

    $(document).click(function () {
        $(".social-hover").removeClass("changing-social");
    });

    /*
    |--------------------------------------------------------------------------
    | Resource Filter Dropdown
    |--------------------------------------------------------------------------
    */
    var $dropdownFilter = $('.dropdown-filter');

    $('.product-list').on('change', function () {
        $('.product-list').not(this).prop('checked', false);
    });

    $(".waystar-filter").click(function (e) {
        $dropdownFilter.toggle();
        e.stopPropagation();
    });

    $dropdownFilter.click(function (e) {
        e.stopPropagation();
    });

    $(document).click(function () {
        $dropdownFilter.hide();
    });

    $('.js-hide-filter').click(function () {
        $dropdownFilter.hide()
    });

    $('.js-clear-filter').click(function(){
        $('.js-filter-checkbox').each(function(){
            $(this).prop('checked', false);
        });
        $('.search-box').val('');
        clearFilters($(this).attr('data-action'));
    });

    function clearFilters(action) {
        $.ajax({
            cache: true,
            type: 'GET',
            url: window.waystar_params.endpoint,
            data: {
                _ajax_nonce: waystar_params.security,
                action: action,
                paged: 1,
                current_url: window.location.href
            },
            success: function (response) {
                $('.js-list-wrapper').html(response);
            },
            error: function (jqXHR, textStatus) {
                $('.js-list-wrapper').html(textStatus);
            }
        });
    }

    /*
    |--------------------------------------------------------------------------
    | Blog Sidebar
    |--------------------------------------------------------------------------
    */
    $('.blog-sidebar .postform').on('change', handleSearch);

    $('.blog-sidebar #search-val').on('keypress', function (e) {
        if (e.which === 13) {  // enter
            handleSearch();
        }
    });

    function handleSearch() {
        var category   = jQuery('.postform').val();
        var search_val = jQuery('#search-val').val();

        window.location.href = home_url + "/insights-resources/blog/?cat=" + category + "&st=" + search_val;
    }

    // Mobile Nav functionality (turn on child menu)
    // if (!!('ontouchstart' in window)) {
    //     $('.navbar-nav .has-children > .nav-link').on('click', function (e) {
    //
    //         // If menu item isn't open, prevent link from firing
    //         if (!$(this).next().hasClass('turn-on')) {
    //             e.preventDefault();
    //         }
    //
    //         // Remove class in case another menu item was clicked (quick cheat)
    //         $('.navbar-nav .has-children > .nav-link').next().removeClass('turn-on');
    //
    //         // Add class to menu item for allowing link to fire
    //         $(this).next().addClass('turn-on');
    //     });
    // }
});